import { UntypedFormGroup } from '@angular/forms';
import { HydraError } from '@adeo/ngx-kozikaza-api';

export const handleHydraError = (form: UntypedFormGroup, hydraError: HydraErrorFull, defaultMsg = 'API Error', outputProperty = false): string => {
  let msg = '';
  if (hydraError && hydraError.violations && hydraError.violations.length > 0) {
    hydraError.violations.forEach((violation) => {
      if (violation.propertyPath) {
        msg += (outputProperty ? `${violation.propertyPath} : ` : '') + violation.message + '\n';
        form.get(violation.propertyPath).setErrors({apiError: violation.message});
      } else {
        msg += violation.message + '\n';
      }
    });
  } else if (hydraError['hydra:description']) {
    const fieldError = hydraError['hydra:description'];
    const fieldArray = fieldError.split(':');
    const field = fieldArray[1] ? fieldArray[0] : null;
    msg += (fieldArray[1] ? fieldArray[1].trim() : fieldError) + '\n';
    if (field) {
      form.get(field).setErrors({apiError: msg});
    }
  } else {
    return defaultMsg;
  }
  return msg;
};

export interface HydraErrorFull extends HydraError {
  violations: Array<{message: string; propertyPath: string}>;
}
